import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { router } from "./router";
import { useAuthStore } from "./stores/auth";
import { useI18nStore } from "./stores/i18n";
import { bootstrapNative } from "./lib/nativeBootstrap";
import "./styles.css";
import "@tabler/icons-webfont/dist/tabler-icons.min.css";

const app = createApp(App);
app.use(createPinia());
app.use(router);

// Init auth before mounting so router guards have user state
const authStore = useAuthStore();
authStore.init();

// Init i18n - watches auth profile for locale sync
const i18nStore = useI18nStore();
i18nStore.syncFromProfile();

app.mount("#app");

// Native platform setup (no-op on web). Call after mount so Vue is painted
// before we hide the splash screen.
bootstrapNative();
